import Timeline from '@mui/lab/Timeline'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import Typography from '@mui/material/Typography'

import type { SaleEvent, SaleStatus } from '~/sales/schema'
import { formatDate } from '~/utils'
import SaleSection from './sale-section'

type Props = {
    saleEvents: Omit<SaleEvent, 'sale'>[]
    saleStatusMap: Map<SaleStatus, string>
}

export default function SaleHistory({ saleEvents, saleStatusMap }: Props) {
    return (
        <SaleSection label={gettext('History')}>
            <Timeline sx={{ p: 1 }}>
                {saleEvents?.map((saleEvent, i) => (
                    <TimelineItem key={i}>
                        <TimelineOppositeContent>
                            <Typography variant="caption">
                                {saleStatusMap.get(saleEvent.status)}
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot variant="outlined" color="primary" />
                            {(i + 1) % saleEvents.length ? <TimelineConnector /> : undefined}
                        </TimelineSeparator>
                        <TimelineContent>
                            <Typography
                                variant="caption"
                                sx={{ color: (theme) => theme.palette.grey[700] }}
                            >
                                {formatDate(saleEvent.date, { format: 'll HH:mm' })}
                            </Typography>
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </SaleSection>
    )
}
